<template>
    <app-layout :title="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmAnnotation">
        <span class="invisible bg-yellow-500"></span> <!--mix yellow bg for dynamic input dummy-->
        <span class="invisible bg-yellow-300"></span> <!--mix yellow bg for dynamic input dummy-->
        <span class="invisible bg-red-500"></span> <!--mix red bg for dynamic input dummy-->
        <span class="invisible bg-green-500"></span> <!--mix green bg for dynamic input dummy-->

        <div class="py-6 px-4 sm:px-6 md:px-8">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-0 md:col-span-3">
                <form @submit.prevent="send" autocomplete="off" action="#" method="POST">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

                            <div class="flex items-center">
                                <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                    Základní údaje
                                </h4>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>

                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-6">
                                    <label for="sender" class="block text-sm font-medium text-gray-700">Odesílatel</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmSender" required type="text" name="sender" id="sender" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>
                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-6">
                                    <label for="recipient" class="block text-sm font-medium text-gray-700">Adresát</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmRecipient" required type="text" name="recipient" id="recipient" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>
                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-6">
                                    <label for="subject" class="block text-sm font-medium text-gray-700">Předmět</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmAnnotation" required type="text" name="subject" id="subject" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>

                            <div v-if="showMoreFields" class="flex items-center">
                                <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                    Pomocné údaje
                                </h4>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>
                            <div v-if="showMoreFields">
                                <label for="to_hands" class="block text-sm font-medium text-gray-700">K rukám</label>
                                <div class="mt-1">
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmToHands" type="text" name="to_hands" id="to_hands" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>

                            <div v-if="showMoreFields" class="flex items-center">
                                <button type="button" :class="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmPersonalDelivery === 'true' ? 'bg-indigo-600' : 'bg-gray-200' " class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <span class="sr-only">Use setting</span>
                                    <span aria-hidden="true" :class="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmPersonalDelivery === 'true' ? 'translate-x-5' : 'translate-x-0' " class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                </button>
                                <span class="ml-3">
                                      <span class="text-sm font-medium text-gray-900">Zpráva typu "do vlastních rukou"</span>
                                    </span>
                            </div>

                            <!--//todo zjistit pusblish identity rozdil here-->



                            <div v-if="showMoreFields" class="flex items-center">
                                <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                    Zmocnění (zákon, paragraf...)
                                </h4>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>

                            <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                <div class="col-span-1">
                                    <label for="law_num" class="sr-only">Číslo</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmLegalTitleLaw" type="text" name="law_num" id="law_num" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-1">
                                    <input disabled type="text" class="disabled:opacity-100 block w-full sm:text-sm rounded-md" placeholder="/" value="/">
                                </div>
                                <div class="col-span-1">
                                    <label for="law_year" class="sr-only">Rok</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmLegalTitleYear" type="text" name="law_year" id="law_year" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-1">
                                    <label for="law_section" class="sr-only">Paragraf</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmLegalTitleSect" type="text" name="law_section" id="law_section" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-1">
                                    <label for="law_paragraph" class="sr-only">Odstravec</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmLegalTitlePar" type="text" name="law_paragraph" id="law_paragraph" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-1">
                                    <label for="law_point" class="sr-only">Písmeno</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmLegalTitlePoint" type="text" name="law_point" id="law_point" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>



                            <div v-if="showMoreFields" class="flex items-center">
                                <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                    Jednací a spisové značky
                                </h4>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>


                            <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                <div class="col-span-3">
                                    <label for="sedner_ref" class="block text-sm font-medium text-gray-700">Č. jednací odesílatele</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmSenderRefNumber" required type="text" name="sender_ref" id="sedner_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-3">
                                    <label for="sedner_ident" class="block text-sm font-medium text-gray-700">Spisová značka odesílatele</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmSenderIdent" required type="text" name="sender_ident" id="sedner_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>


                            <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                <div class="col-span-3">
                                    <label for="recipient_ref" class="block text-sm font-medium text-gray-700">Č. jednací příjemce</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmRecipientRefNumber" required type="text" name="sender_ref" id="recipient_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <div class="col-span-3">
                                    <label for="recipient_ident" class="block text-sm font-medium text-gray-700">Spisová značka příjemce</label>
                                    <input disabled v-model="deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmRecipientIdent" required type="text" name="sender_ident" id="recipient_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>






                            <div class="flex items-center">
                                <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                    Události
                                </h4>
                                <div class="flex-1 border-t-2 border-gray-200"></div>
                            </div>

                            <!-- TW Snippet Start v2.0+ -->
                            <div id="events" class="flow-root mt-4">
                                <ul class="-mb-8">

                                    <li v-for="(event, index)
                                    in Array.isArray(deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmEvents.dmEvent) ?
                                    deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmEvents.dmEvent
                                    : [deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmEvents.dmEvent]">
                                        <div class="relative pb-8">
                                            <span v-if="index !== deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmEvents.dmEvent.length - 1" class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                                            <div class="relative flex space-x-3">
                                                <div>
                                                    <span
                                                        :class="EVColors[event.dmEventDescr.split(':')[0]]"
                                                        class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white">

                                                        <span v-html="EVIcons[event.dmEventDescr.split(':')[0]]"> </span>
                                                    </span>
                                                </div>
                                                <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                                    <div>
                                                        <p class="text-sm text-gray-500"> {{ event.dmEventDescr }}</p>
                                                    </div>
                                                    <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                                        <time class="whitespace-no-wrap"> {{ (new Date(event.dmEventTime).toLocaleDateString('cs-cs')) }} </time>
                                                        <br>
                                                        <time class="whitespace-no-wrap"> {{ (new Date(event.dmEventTime).toLocaleTimeString('cs-cs')) }} </time>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>



                        </div>
                        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <div class="inline float-left items-center">
                                <a v-if="!showMoreFields" @click="showMoreFields = true" href="#" class="text-left pr-4 text-sm font-semibold text-indigo-600">
                                    Další možnosti (k rukám, zmocenění, jednací a spisové značky...)
                                </a>
                            </div>

                            <a :download="'dorucenka ' + deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmID + '.zfo'" :href="route('downloadDeliveryInfoZfo', {id: deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmDm.dmID})">
                            <jet-button type="button">
                                Stáhnout
                            </jet-button>
                            </a>


                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetButton from "@/Jetstream/Button";
export default {
    name: "ViewDeliveryInfo",
    components: {
        AppLayout,
        JetButton
    },
    data() {
        console.log(this.$page.props.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmEvents);
        return {
            deliveryInfoId: this.$page.props.deliveryInfoId,
            deliveryInfo: this.$page.props.deliveryInfo,

            showMoreFields: false,
            EVColors: this.$page.props.EVColors,
            EVIcons: this.$page.props.EVIcons,
        }
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
